import { render, staticRenderFns } from "./AllCategoryIndex.vue?vue&type=template&id=2d408b3c&scoped=true"
import script from "./AllCategoryIndex.vue?vue&type=script&lang=js"
export * from "./AllCategoryIndex.vue?vue&type=script&lang=js"
import style0 from "./AllCategoryIndex.vue?vue&type=style&index=0&id=2d408b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d408b3c",
  null
  
)

export default component.exports